import { cva } from "../../../node_modules/.pnpm/class-variance-authority@0.7.1/node_modules/class-variance-authority/dist/index.js";
const avatarVariants = cva(
  "flex shrink-0 items-center justify-center overflow-hidden bg-(--avatar-bg-color)",
  {
    variants: {
      size: {
        custom: "w-(--avatar-size) h-(--avatar-size) text-[calc(var(--avatar-size)_/_2)]",
        // 根据design预定义的样式
        size1: "size-6  text-xs          [&_svg:not([class*='size-'])]:size-3",
        size2: "size-8  text-sm          [&_svg:not([class*='size-'])]:size-3",
        size3: "size-10 text-base        [&_svg:not([class*='size-'])]:size-3",
        size4: "size-12 text-lg          [&_svg:not([class*='size-'])]:size-4.5",
        size5: "size-16 text-2xl         [&_svg:not([class*='size-'])]:size-5",
        size6: "size-20 text-[1.75rem]   [&_svg:not([class*='size-'])]:size-6",
        size7: "size-24 text-[1.75rem]   [&_svg:not([class*='size-'])]:size-6",
        size8: "size-32 text-[2.1875rem] [&_svg:not([class*='size-'])]:size-8",
        size9: "size-40 text-6xl         [&_svg:not([class*='size-'])]:size-10"
      },
      rounded: {
        circle: "rounded-full",
        square: "rounded-(--avatar-border-radius)",
        // 根据design预定义的样式
        "size1-square": "rounded-sm",
        "size2-square": "rounded-sm",
        "size3-square": "rounded-md",
        "size4-square": "rounded-md",
        "size5-square": "rounded-lg",
        "size6-square": "rounded-xl",
        "size7-square": "rounded-xl",
        "size8-square": "rounded-2xl",
        "size9-square": "rounded-2xl"
      }
    },
    defaultVariants: {
      size: "custom",
      rounded: "circle"
    }
  }
), avatarListVariants = cva(
  "flex",
  {
    variants: {
      wrap: {
        default: "",
        wrap: "flex-wrap"
      }
    },
    defaultVariants: {
      wrap: "default"
    }
  }
), avatarItemVariants = cva("border-3 border-(--gray-border-2) dark:border-(--gray-text-2)");
export {
  avatarItemVariants,
  avatarListVariants,
  avatarVariants
};
//# sourceMappingURL=variants.js.map
